import { useState } from 'react'

import { reject, isEmpty } from 'lodash'
import { Box, TextField, Typography } from '@material-ui/core'

import { getSegmentValue, getUpdatedSegment } from './segment-service'
import { withContext } from './Context'

export const HSSID_SEGMENT = 'HighSchoolStudentId'
export const UUID_SEGMENT = 'UUID'
export const CRITERIA = 'Must'

// eslint-disable-next-line no-useless-escape
const regex = /\,|\n/
const getArray = (value: string) => reject(value.split(regex), isEmpty)
const isUsingUUID = (values: string[]) => values.length > 0 && values[0].length === 32

interface IManualStudentSelectorProps {
  segment: Partial<Record<string, any>> // segmentation object defined in segment-service.js
  updateSegment: (arg0: Partial<Record<string, any>> /* segmentation object defined in segment-service.js */) => void
}

export const ManualStudentSelector = ({ segment, updateSegment }: IManualStudentSelectorProps) => {
  const [touched, setTouched] = useState(false)
  const [currentSegmentName, setCurrentSegmentName] = useState(HSSID_SEGMENT)
  const currentValue = getSegmentValue(segment, CRITERIA, currentSegmentName)
  const count = currentValue.length
  const invalid = count === 0 && touched

  const updateStudentIDSegment = (values: string[]) => {
    // use UUID if the first value is 32 characters long, otherwise use HSSID
    const segmentName = isUsingUUID(values) ? UUID_SEGMENT : HSSID_SEGMENT
    let updatedSegment = getUpdatedSegment(segment, CRITERIA, segmentName, values)

    // if the segment name has changed, clear the current segment values
    if (segmentName !== currentSegmentName) {
      updatedSegment = getUpdatedSegment(updatedSegment, CRITERIA, currentSegmentName, [])
      setCurrentSegmentName(segmentName)
    }
    updateSegment(updatedSegment)
  }

  return (
    <Box mt={4}>
      <Typography
        component="label"
        variant="subtitle2"
        htmlFor="manual-student-ids"
      >
        Input Scoir Student IDs from your CRM
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        Please ensure IDs are comma or newline delimited, avoiding special characters like quotes or spaces around the
        IDs.
      </Typography>
      <Box mt={2}>
        <TextField
          id="manual-student-ids"
          multiline
          variant="outlined"
          error={invalid}
          minRows={6}
          maxRows={20}
          fullWidth
          helperText={invalid ? 'At least one Student ID is required.' : undefined}
          onChange={(e) => {
            setTouched(true)
            updateStudentIDSegment(getArray(e.target.value))
          }}
        />
      </Box>
      <Box mt={1}>
        <Typography
          aria-label={`Student ID Count: ${count}`}
          variant="body2"
          align="right"
          color={invalid ? 'error' : 'textSecondary'}
        >
          <strong>{count}</strong> Scoir Student ID{count === 1 ? '' : 's'}
        </Typography>
      </Box>
    </Box>
  )
}

export default withContext(ManualStudentSelector)
